import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Navigation from "../components/nav"
import {
  
  faShoppingCart,
  faUser,
  faUtensils,
} from "@fortawesome/free-solid-svg-icons";

import React from "react";
import Breadcrumbs from "../utils/Breadcrumb";
const serviceItems = [
  {
    icon: faUser,
    title: "Master Chef",
    description: "Indulge in the exquisite culinary creations of our master chefs. Each dish is a work of art, meticulously prepared to tantalize your taste buds.",
  },
  {
    icon: faUtensils,
    title: "Quality Food",
    description: "Savor the goodness of quality food made with the finest ingredients. Our commitment to quality ensures a delightful and nourishing dining experience.",
  },
  {
    icon: faShoppingCart,
    title: "Online Order",
    description: "Enjoy the convenience of ordering your favorite dishes online. Explore our menu, place your order, and have it delivered to your doorstep hassle-free.",
  },
  {
    icon: faShoppingCart,
    title: "Express Delivery",
    description: "Experience the speed of our express delivery service. Your orders will reach you promptly, ensuring that you get your favorite meals without any delay.",
  },
  {
    icon: faShoppingCart,
    title: "Custom Catering",
    description: "Make your events memorable with our custom catering service. From weddings to corporate gatherings, we create tailored menus to suit every occasion.",
  },
  {
    icon: faShoppingCart,
    title: "Special Discounts",
    description: "Unlock exclusive discounts and offers when you order online. Save more while enjoying your favorite meals with our special discount programs.",
  },
  {
    icon: faShoppingCart,
    title: "Loyalty Rewards",
    description: "Join our loyalty program and earn rewards with every order. Get exciting perks, discounts, and freebies as a token of appreciation for your continued support.",
  },
  {
    icon: faShoppingCart,
    title: "Customer Support",
    description: "Our dedicated customer support team is here to assist you. Have questions, feedback, or concerns? Reach out to us anytime, and we'll be happy to help.",
  },
  // Add more service items as needed
];


export default function Services() {
  return (
    <>
    <Navigation />
    <Breadcrumbs />

    <div className="mt-24 p-2">
      <div className="flex mx-4 md:mx-auto text-center place-content-center">
        <div className="border-b-4 border-amber-400 h-4 w-10 sm:w-16 flex items-center justify-center ml-2 sm:ml-5"></div>

        <p className="text-center text-xl sm:text-2xl text-amber-400 font-bold mb-2 font-nav">
          Services
        </p>
        <div className="border-b-4 border-amber-400 h-4 w-10 sm:w-16 flex items-center justify-center ml-2 sm:ml-5"></div>
      </div>
      <p className="text-2xl font-bold text-center p-2">Explore Our Services</p>

      {/* Services grid  */}

      <div className="grid gap-4 grid-cols-1 md:grid-cols-3 shadow lg:grid-cols-4 md:mx-36">
        {serviceItems.map((item, index) => (
          <div key={index} className="border bg-white p-6">
            <div className="mb-4">
              <FontAwesomeIcon
                icon={item.icon}
                style={{ color: "#fb9b59", fontSize: "3em" }}
              />
            </div>
            <div className="font-bold text-lg mb-2">{item.title}</div>
            <div className="text-gray-600">{item.description}</div>
          </div>
        ))}
      </div>
    </div>
    </>
  );
}
